import { FFormChildMDP } from "../FFormDrawerMDP";
import FFieldMDP from "./FFieldMDP";

export default class FRangeSliderSPAMDP implements FFieldMDP {
  componentName = "FRangeSliderSPA";
  dataSelectorKey: any;
  label: string;
  type: string;
  rules: string;
  mandatory: boolean;
  parentMDP: FFormChildMDP;
  boundaryClass: string;
  disabled: boolean;
  condition: boolean;
  outstanding?: number;
  affordability?: number;
  tenureApproval?: number;
  totalPercentage: number;
  spaPaidCount?: number;
  constructor({
    parentMDP,
    dataSelectorKey='',
    label = '',
    type = "text",
    rules = "",
    mandatory = false,
    boundaryClass = "col-12",
    disabled = false,
    condition = true,
    outstanding,
    affordability,
    tenureApproval,
    totalPercentage,
    spaPaidCount=0
  }: {
    parentMDP: FFormChildMDP;
    dataSelectorKey: string;
    label?: string;
    type?: string;
    rules?: any;
    mandatory?: boolean;
    boundaryClass?: string;
    disabled?: boolean;
    condition?: boolean;
    affordability?: number;
    tenureApproval?: number;
    outstanding?: number;
    totalPercentage: number;
    spaPaidCount?: number;
  }) {
    this.parentMDP = parentMDP;
    this.dataSelectorKey = dataSelectorKey;
    this.label = label;
    this.type = type;
    this.rules = rules;
    this.mandatory = mandatory;
    this.boundaryClass = boundaryClass;
    this.disabled = disabled;
    this.condition = condition;
    this.outstanding = outstanding;
    this.affordability = affordability;
    this.tenureApproval = tenureApproval;
    this.totalPercentage = totalPercentage;
    this.spaPaidCount = spaPaidCount;
  }

  getRules() {
    const required = this.mandatory ? "required" : "";
    return `${required}|${this.rules}`;
  }

  getBoundaryClass() {
    return `${this.boundaryClass} py-0 px-2`;
  }

  getMetaData(): object {
    return {
      componentName: this.componentName,
      dataSelectorKey: this.dataSelectorKey,
      rules: this.getRules(),
      boundaryClass: this.getBoundaryClass(),
      condition: this.condition,
      props: {
        id: this.dataSelectorKey,
        label: this.label,
        type: this.type,
        outlined: this.parentMDP.outlined,
        dense: this.parentMDP.dense,
        disabled: this.disabled,
        outstanding: this.outstanding,
        affordability: this.affordability,
        tenureApproval: this.tenureApproval,
        totalPercentage: this.totalPercentage,
        spaPaidCount: this.spaPaidCount
      },
    };
  }
}
